var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTlcPostpone = function SvgIconTlcPostpone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.005 4.002c0-2.21 1.792-4.002 4.002-4.002s4.001 1.792 4.001 4.002-1.791 4.001-4.001 4.001c-2.21 0-4.002-1.791-4.002-4.001z",
    transform: "translate(-327 -330) translate(263.262 111) translate(64.738 219.868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.011 3.767C10.941 3.28 9.756 3 8.504 3 3.808 3.001 0 6.81 0 11.505s3.808 8.503 8.504 8.503c4.695 0 8.503-3.807 8.503-8.503 0-1.253-.279-2.437-.765-3.508M17.257 4.066L14.756 4.066M16.007 2.815L16.007 5.316",
    transform: "translate(-327 -330) translate(263.262 111) translate(64.738 219.868)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.236 7.711L8.236 12.106 11.691 14.212",
    transform: "translate(-327 -330) translate(263.262 111) translate(64.738 219.868)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTlcPostpone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-tlc-postpone.2c1c61b8707f7d6476380f0c76d02441.svg";